import { render, staticRenderFns } from "./Mutations.vue?vue&type=template&id=08f5690a&lang=pug&"
import script from "./Mutations.vue?vue&type=script&lang=js&"
export * from "./Mutations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports